import React, { Component } from 'react';

// Styles
import './styles.scss';

// Constants
import { columns, ENT_ROLES_MAPPING } from './usersTableData';
import { DeviceType } from 'src/Components/TableList/components/TableRow/TableRow';

// Components
import InitialsPicture from 'src/Components/InitialsPicture/InitialsPicture';
import TableList from 'src/Components/TableList/TableList';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import SecondaryButton from 'src/Components/SecondaryButton/SecondaryButton';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';

class UserListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isArrowShowingUp: true,
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: window.innerWidth < DeviceType.Phone ? true : false,
      showConfirmation: false,
    };
  }

  updateDimensions = () => {
    if (window.innerWidth < DeviceType.Phone) {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: true,
      });
    } else {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: false,
      });
    }
  };
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  // Constructs the JSX for "name" cell in table row
  getNameObject = (user) => {
    const { activePage } = this.props;
    return (
      <div className="img-name-role-cell-wrapper">
        <InitialsPicture
          name={user.name ? user.name : 'N V'}
        />
        <span className="name-role-container">
          <span
            className={`name-container ${
              activePage === 'customerUsers' ? 'underline' : ''
            }`}
            onClick={
              activePage === 'customerUsers'
                ? this.showUserModal.bind(this, user)
                : () => {
                    /* Empty function for default */
                  }
            }
          >
            {user?.name?.replace('~',' ')}
          </span>
          <span className="role-container">
            {user?.role && user.role !== 'null' ? user.role: '-'}
          </span>
        </span>
      </div>
    );
  };

  showUserModal = (user) => {
    this.props.getUserDetails(user);
  };

  disableAccount = (val) => {
    this.setState({
      showConfirmation: val,
    });
  };

  updateUserDetails = (user, isDisabled) => {
    this.props.updateUser(user, isDisabled);
  };

  // Constructs the JSX for "role" cell in table row
  getRoleObject = (entRoles, active) => {
    const { t } = this.props;
    let rolesToDisplay = [];
    // Case for Disabled user
    if (!active) {
      rolesToDisplay.push(t('disabledText'));
    } else if (entRoles.includes('ADMIN')) {
      rolesToDisplay.push(ENT_ROLES_MAPPING['ADMIN']);
    } else if (entRoles.includes('PARTICIPANT')) {
      rolesToDisplay.push(ENT_ROLES_MAPPING['PARTICIPANT']);
    }
    return (
      <div className="ent-role-cell-wrapper">
        <span className="primary-value__ent-role">
          {' '}
          {rolesToDisplay[0]}​​​​​​
        </span>
        {rolesToDisplay[1] && (
          <span className="secondary-value__ent-role">
            {' '}
            {rolesToDisplay[1]}​​​​​​
          </span>
        )}
      </div>
    );
  };

  getFacilityObject = (dataRow) => {
    return (
      <div className="facility-cell-wrapper">
        <span className="facility-cell-wrapper__facility-name">
          {dataRow?.primaryFacilityName}
        </span>
      { dataRow.street ? <><span className="facility-cell-wrapper__facility-address">
          {dataRow.street}
        </span>
        <span className="facility-cell-wrapper__facility-address">
          {`${dataRow.city}, ${dataRow.state}, ${dataRow.postalCode} ${dataRow.country}`}
        </span></> :<>-</>}
      </div>
    );
  };

  getDisableButtons = (_key, user) => {
    let { showConfirmation } = this.state;
    let { isDisabled, t } = this.props;
    return (
      <div className="buttons-container">
        {showConfirmation ? (
          <div className="user-confirmation-wrapper">
            <p className="confirm-heading">{t('confirmationHeading')}</p>
            <div className="confirm-buttons">
              <PrimaryButtonGE
                text={t('confirmDisableAccount')}
                disabled={false}
                onClick={this.updateUserDetails.bind(this, user, isDisabled)}
              />
              <SecondaryButton
                text={t('cancel')}
                onClick={this.disableAccount.bind(this, false)}
              />
            </div>
          </div>
        ) : (
          <>
            {this.renderDisableButton()}
          </>
        )}
      </div>
    );
  };

  renderDisableButton = () =>{
    let { isDisabled, t } = this.props;
    if(!isDisabled)
    {
      return(<div className="button-wrapper">
      <span
        className="cell__link"
        role="button"
        tabIndex={0}
        onClick={this.disableAccount.bind(this, true)}
      >
        {t('disableDEAccount')}
      </span>
      </div>);
    }
    else
    {
      return(<div className="button-wrapper">
      <SecondaryButton
        text={t('grantDEAccess')}
        onClick={this.updateUserDetails.bind(this, user, isDisabled)}
      />
      </div>);
    }
  }

  customRenderingFn = (_colValue, column, uniqueKey, indexKey, dataRow) => {
    let customValue = '';
    if (column.key === 'name') {
      customValue = this.getNameObject(dataRow);
    }
    if (column.key === 'role') {
      customValue = this.getRoleObject(dataRow.entRoles, dataRow.active);
    }
    if (column.key === 'facility') {
      customValue = this.getFacilityObject(
        dataRow
      );
    }
    if (column.key === 'disable') {
      customValue = this.getDisableButtons(indexKey, dataRow);
    }
    return (
      <div
        key={`${uniqueKey}`}
        className={`column-container row-${column.widthInPercent}`}
      >
        {customValue}
      </div>
    );
  };

  handleClickNavigate = (_row) => {
    console.log('\n Customer handleClickNavigate----------');
  };

  actionBtnClick = (data, e) => {
    const { usersList = [] } = this.props;

    e.stopPropagation();

    window.digitalData.link = {
      linkName:
        e.target.innerText.toLowerCase() === 'manage'
          ? e.target.innerText + ' team member'
          : e.target.innerText,
      linkType: 'table row',
    };
    AnalyticsService.trackEvent('link_click');

    let user =
      usersList && usersList.length > 0
        ? usersList.filter((i) => i.email === data.email)[0]
        : null;

    if (user) {
      this.props.handleBtnClick(data);
    }
  };

  // Clears the row data is the user is disabled/not active
  emptyDisabledUsers = (list = []) =>
    list.map((user) => {
      if (!user.active) {
        for (const key in user) {
          if (
            key !== 'active' &&
            key !== 'name' &&
            key !== 'role' &&
            key !== 'email'
          ) {
              if(key === 'department')
              {
                user[key] = '  ';
              }
              else{
                user[key] = '';
              }
          }
        }
      }
      return user;
    });
  

  render() {
    // Should never default the totalItems as we may receive response with an exception, defaulting to some number will try to load the table.
    const {
      usersList = [],
      totalItems,
      totalPages,
      pageNumber,
      activePage,
      searchKey,
      loadMore = () => {
        /* Empty function for default */
      },
      sortedItem,
      t
    } = this.props;
    const { isMobile } = this.state;
    const emptySearchMessage = {
      error: t('emptyPersonSearchText'),
      msg: t('emptyPersonSearchSubtext'),
    };
    return (
      <div className="user-list-table-wrapper">
        <TableList
          columnList={columns[`${activePage + 'Columns'}`]}
          onSortHandler={(sortBy) => {
            this.props.sortUsers(sortBy);
          }}
          sortedItem={sortedItem}
          dataList={this.emptyDisabledUsers(usersList)}
          pageNumber={pageNumber ? pageNumber : 0}
          totalItems={totalItems ? totalItems : 0}
          totalPages={totalPages ? totalPages : 0}
          searchKey={searchKey}
          loadMore={loadMore}
          customRendering={this.customRenderingFn}
          handleClickNavigate={this.handleClickNavigate}
          selectButtonHandler={this.actionBtnClick}
          emptySearchMessage={emptySearchMessage}
          clickHandler={(_event, column) => {
            window.location = column.url;
          }}
          accordionColumns={columns[`${activePage + 'AccordionColumns'}`]}
          isMobile={isMobile}
        />
      </div>
    );
  }
}
export default withTranslation()(UserListTable);
